// @ts-nocheck

export const localeCodes =  [
  "en",
  "de"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_4d5c7ba3",
      load: () => import("#nuxt-i18n/4d5c7ba3" /* webpackChunkName: "locale_en_46ts_4d5c7ba3" */),
      cache: false
    }
  ],
  de: [
    {
      key: "locale_de_46ts_5b87f620",
      load: () => import("#nuxt-i18n/5b87f620" /* webpackChunkName: "locale_de_46ts_5b87f620" */),
      cache: false
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: "en-US",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "de",
    name: "Deutsch",
    language: "de-DE",
    domains: [],
    defaultForDomains: []
  }
]

